<div class="modal-header">
  <h5 class="modal-title">Add Notes</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="notesForm">
    <div formArrayName="notes">
      <div *ngFor="let noteGroup of notes.controls; let i = index" class="mb-3 note-item">
        <div [formGroupName]="i">
          <div class="mb-2">
            <input 
              type="text" maxlength="255"
              class="form-control note-title" 
              formControlName="title"
              placeholder="Note Title"
              (input)="sanitizeInput($event,'title')" autocomplete="off" autocorrect="off"
            >
            <p class="textCount">{{ titleLengths[i] || 0 }}/255</p>

            <!-- <div *ngIf="noteGroup.get('title')?.invalid && noteGroup.get('title')?.touched" class="text-danger mt-1">
              <small *ngIf="noteGroup.get('title')?.errors?.['required']">Title is required</small>
            </div> -->
          </div>
          <div class="d-flex align-items-start">
            <div class="flex-grow-1">
              <textarea 
                class="form-control note-content" 
                formControlName="content"
                rows="3" maxlength="500"
                placeholder="Add your note content here..."
                (input)="sanitizeInput($event,'content')" autocomplete="off" autocorrect="off"
              required></textarea>
              <p class="textCount">{{contentLength}}/500</p>
              <!-- <div *ngIf="noteGroup.get('content')?.invalid" class="text-danger mt-1">
                <small *ngIf="noteGroup.get('content')?.errors?.['required']">Content is required</small>
              </div> -->
              <div *ngIf="notesForm.get('content')?.invalid && notesForm.get('content')?.touched" class="text-danger small">
                Content is required
              </div>

            </div>
            <button *ngIf="notes.length > 1" type="button" class="btn btn-sm btn-outline-danger ms-2 delete-btn" (click)="removeNote(i)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="d-flex justify-content-end mt-3">
      <button type="button" class="btn btn-outline-primary" (click)="addNote()">
        <i class="bi bi-plus-circle me-1"></i> Add Another Note
      </button>
    </div> -->
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="dismiss()">Cancel</button>
  <button 
    type="button" 
    class="btn btn-primary" 
    [disabled]="notesForm.invalid || isSubmitting" 
    (click)="onSubmit()">
    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
    Submit
  </button>
</div>